<template>
  <div class="main-body fill-height">
    <OnboardingNav />
    <!-- onboarding 1st step -->
    <v-layout row wrap class="row fill-height" id="onboarding-1">
      <v-flex xs12 md3 lg3 class="flex1">
        <div class="content-area">
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Add a Brand/Location
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Add Staff
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Menu Category
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Menu Setup
            </p>
            <v-divider />
          </div>
        </div>
        <div class="footer">
          <p><router-link to="/" class="link">Exit Setup</router-link></p>
        </div>
      </v-flex>
      <v-flex xs12 md9 lg9 class="flex2">
        <div class="flex2-content">
          <h4>Let's Create your first brand and Location</h4>
          <span
            >We will create your first brand which can be listed in multiple
            locations. This brand will be your <br />
            default brand and can be changed later in the settings menu.
          </span>
          <div class="form-area">
            <v-form ref="onboarding1">
              <div class="form-group">
                <label for="brand name">Brand name</label>
                <v-text-field
                  outlined
                  v-model="brandName"
                  dense
                  height="48"
                  placeholder="Enter brand name"
                  class="v-text-field"
                  :rules="[rules.required]"
                ></v-text-field>
              </div>
              <div class="form-group">
                <label for="country location">Name of Location</label>
                <v-text-field
                  outlined
                  v-model="location"
                  dense
                  height="48"
                  label=""
                  :rules="[rules.required]"
                ></v-text-field>
              </div>
              <div class="form-group">
                <label for="address">Address</label>
                <v-text-field
                  outlined
                  dense
                  height="48"
                  v-model="address"
                  placeholder="Enter the address of this restaurant"
                  :rules="[rules.required]"
                ></v-text-field>
              </div>
            </v-form>
            <div>
              <v-layout row wrap style="margin-top: 5%">
                <v-flex xs6 md2 lg2> </v-flex>
                <v-flex xs6 md10 lg10>
                  <v-btn
                    class="success"
                    :loading="nextLoading"
                    @click.prevent="addBrandLocation"
                    id="next-btn"
                    >Next</v-btn
                  >
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import all_countries from "../../utils/countries.json";
import OnboardingNav from "../../components/onboarding/OnboardingNav";
import axios from "axios";
import { mapState } from "vuex";

export default {
  components: {
    OnboardingNav,
  },
  data() {
    return {
      nextLoading: false,
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      brandName: "",
      location: "",
      address: "",
      brandID: null,
      isBrandAdded: false,
      isLocationAdded: false,
      filteredCountries: [],
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
        email: (value) =>
          !value ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          "Invalid E-mail",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    async addBrandLocation() {
      if (this.$refs.onboarding1.validate()) {
        await this.addBrand();
        await this.addLocation();

        if (this.isBrandAdded == true && this.isLocationAdded == true) {
          await this.updateMeta();

          // Goto next state
          setTimeout(() => {
            this.$router.push("/onboarding-2");
            this.nextLoading = false;
          }, 1000);
        } else {
          this.nextLoading = false;
        }
      }
    },
    async addBrand() {
      this.nextLoading = true;
      await axios
        .post(
          "/api/v1/brand",
          {
            brandName: this.brandName,
          },
          { headers: { Authorization: this.$store.state.token } }
        )
        .then((response) => {
          this.isBrandAdded = true;
          // await response;
          this.brandID = response.data.data.id;
          return response;
        })
        .catch((error) => {
          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Brand not addded";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          return error.response;
        });
    },
    async addLocation() {
      await axios
        .post(
          "/api/v1/location",
          {
            locationName: this.location,
            addressLineOne: this.address,
            brandId: this.brandID,
            isOnboarding: true,
          },
          { headers: { Authorization: this.$store.state.token } }
        )
        .then((response) => {
          this.isLocationAdded = true;
          // await response
          return response.status;
        })
        .catch((error) => {
          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Location not addded";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          return error.response.status;
        });
    },
    async updateMeta() {
      let meta = {};
      let onboarding = {};
      onboarding.stage = 1;
      onboarding.status = "incomplete";
      meta.onboarding = onboarding;

      await this.$store
        .dispatch("updateUserProfile", { meta: meta })
        .catch((error) => {
          this.snackBar.active = true;
          this.snackBar.text = "Onboarding Stage not updated";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          return error.response.status;
        });
    },
  },
  created() {
    var data = all_countries;
    var newData = this.filteredCountries;
    data.forEach((item) => {
      newData.push(item.name);
    });
    this.$store.dispatch("getUserDetails");
  },
  computed: {
    ...mapState(["storedUserDetails"]),
  },
  mounted() {},
};
</script>

<style scoped>
.main-body {
  font-family: "Montserrat";
}

.flex2 {
  padding-top: 4%;
  background: white;
}

.flex2-content {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: -2%;
}

.content-area {
  padding-top: 15%;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  color: white;
}

.footer {
  padding-top: 70%;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  color: white;
}

.icon {
  color: green;
  margin-right: 2%;
}

p {
  margin-top: 5%;
}

.link {
  color: #ffffff;
  text-decoration: none;
}

.content-list:hover {
  background: #444444;
  border-radius: 2px;
}

form {
  margin-top: 4%;
}

.form-group {
  width: 50%;
  margin-top: -1%;
}

#next-btn {
  float: right;
  text-transform: capitalize;
  width: 18%;
}

.v-text-field--outlined.v-input--dense .v-label {
  top: 14px;
}

@media only screen and (max-device-width: 480px) {
  .content-list > p {
    font-size: 11px;
  }

  .flex1 {
    height: 300px;
  }
}
</style>
